import { LIGHT_GREEN } from "styles/oneOffColor";

const styles = {
  card: {
    backgroundColor: "#F9FAFB",
    borderRadius: 4,
    py: 2,
    px: 3,
    mt: 4,
  },
  saveBundle: {
    ml: 1,
    color: "purple.main",
    fontWeight: 700,
    fontSize: 12,
  },
  annotationPrice: {
    fontSize: 10,
    textTransform: "none",
    color: "primary.main",
    ml: 1,
    backgroundColor: LIGHT_GREEN,
    borderRadius: 4,
    px: 2,
    py: 0.5,
    width: "fit-content",
  },
  iconButton: {
    fontSize: 12,
    color: "black",
    width: 20,
    height: 20,
  },
  enhance: {
    borderRadius: 4,
    backgroundColor: "#FFDF20",
    my: 1,
    width: "fit-content",
    px: 1,
    py: 0.5,
    fontSize: 12,
  },
};

export default styles;
